#main-wrapper{display:flex;justify-content:space-between;background-color:#f0f1f6;height:100%}#main-wrapper .app-sidebar{display:inline-flex}
/*# sourceMappingURL=full.component-UUWDMB3P.css.map */
